export class Style {
  ml;
  constructor(Style, isRaster) {
    if (Style && Style.StyledLayerDescriptor) {
      this.name = Style?.StyledLayerDescriptor?.NamedLayer?.Name; //nombre del estilo
      this.title = Style?.StyledLayerDescriptor?.Title; //titulo del estilo
      this.rules = Style?.StyledLayerDescriptor?.NamedLayer?.UserStyle?.FeatureTypeStyle.Rule; //reglas del estilo, si solo tiene una regla es un string, si tiene más de una es un array
      this.SLDXml = [];
      this.isRaster = isRaster;
      this.ruleObject = undefined;
    }
  }

  /**
   *
   * @desc función para obtener el nombre del estilo
   */
  getName = () => {
    return this.name;
  };

  /**
   *
   * @desc función para obtener el título del estilo
   */
  getTitle = () => {
    return this.title;
  };

  /**
   *
   * @desc función para obtener las reglas de estilo
   */
  getRules = () => {
    return this.rules;
  };

  /**
   *
   * @desc función para saber si el estilo tiene reglas
   */
  hasRules = () => {
    return this.rules !== undefined;
  };

  /**
   *
   * @desc función para obtener el numero de reglas de estilo que tiene el estilo
   */
  getNumRules = () => {
    if (this.rules && this.rules !== undefined) {
      if (!Array.isArray(this.rules)) return 1; //si no es un array, devolvemos 1 para no iterar en el string
      else return this.rules.length;
    }
  };

  /**
   *
   * @param id posición de la regla en el array de reglas de estilo
   * @desc función para obtener el titulo de una regla de estilo
   */
  getRuleTitle = (id) => {
    if (!Array.isArray(this.rules)) return this.rules.Title; //si no es array, solo hay una rule
    else return this.rules[id].Title;
  };

  /**
   *
   * @param id posición de la regla en el array de reglas de estilo
   * @desc función para obtener el nombre de una regla de estilo
   */
  getRuleName = (id) => {
    if (!Array.isArray(this.rules)) return this.rules.Name; //si no es array, solo hay una rule
    else return this.rules[id].Name;
  };

  /**
   *
   * @param id posición de la regla en el array de reglas de estilo
   * @desc función para obtener una regla de estilo
   */
  getRule = (id) => {
    if (!Array.isArray(this.rules)) return this.rules; //si no es array, solo hay una rule
    else return this.rules[id];
  };

  getSLDUrl = (layer, style) => {
    var esCapaRVCoATC = '';
    if (layer && layer.getOnlineResource()) {
      // Comprovar si es una capa de RVC
      var reg = new RegExp('/RVC/ows');
      var n = layer.getOnlineResource().match(reg);
      if (n != null && n.length > 0) {
        esCapaRVCoATC = '/RVC';
      }
      // Comprovar si es una capa de ATC
      reg = new RegExp('/ATC/ows');
      n = layer.getOnlineResource().match(reg);
      if (n != null && n.length > 0) {
        esCapaRVCoATC = '/ATC';
      }
    }
    if (!window.location.origin) {
      window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }
    if (layer.getStyle(style).getName() !== undefined)
      return window.location.origin + esCapaRVCoATC + '/ows/rest/styles/' + layer.getStyle(style).getName() + '.sld';
    return undefined;
  };

  hasSLDXml = (style) => {
    return this.SLDXml[style] !== undefined;
  };

  setSLDXml = (xml, style) => {
    this.SLDXml[style] = xml;
  };

  getSLDXml = (style) => {
    if (this.SLDXml[style] !== undefined) return this.SLDXml[style];
    return '';
  };

  setRule = (rule) => {
    this.ruleObject = rule;
  };

  getRuleObject = () => {
    return this.ruleObject;
  };

  hasRule = () => {
    return this.ruleObject !== undefined;
  };
}
